module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAzUlEQVQ4T+2TwREBMRiF30sFGQ1wWK62BCqgBFf2ogQluCxXHaADJayrdaABkwryTHYYzAQzXBzkkkPyvpnk/x7x5eJ93ua7lMSSYCPGleAEdV3WKq7nD4BaXk48WbhRsgoXAjDs14Cd7ftGSk9Zc/IUIKgH0kVfJlmC65cAb7Bxw+YmBrDzsmM8On/Az/8BoDoMD1EPvBoAj6/HSDgQlaph5gCtN6rMhJAawb4B3FSu5ftpyJ2yZFyp/U7lS5kWBNvRMkFbCYOnZfqk2Wcr4KERURjx5QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/p.png
// module id = xocM
// module chunks = 1